module.exports = __webpack_public_path__ + "img/mysql.69f01545.jpg";